import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

const getCoreBankingTenantInfo = async () => {
  const response = await getData(ajaxEndpoints.GET_CORE_BANKING_TENANT_INFO);
  return response?.data;
};

export default function useCoreBankingTenantInfo() {
  return useQuery("corebankingtenantinfolist", getCoreBankingTenantInfo, {
    refetchOnWindowFocus: false,
  });
}
